import React, { useEffect, useRef } from 'react';
import { Helmet } from 'react-helmet';

import { DealerRegistrationFormWidget } from '../../../widgets/dealerRegistrationForm';

export const DealerRegistrationForm = () => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const sendHeight = () => {
      if (window.parent === window) {
        return;
      }

      if (!containerRef.current) {
        return;
      }

      const height = containerRef.current.scrollHeight;

      window.parent.postMessage({ type: 'gm-embed-height', height }, '*');
    };

    const resizeObserver = new ResizeObserver(sendHeight);
    resizeObserver.observe(document.body);

    const mutationObserver = new MutationObserver(sendHeight);
    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      characterData: true,
    });

    const interval = setInterval(sendHeight, 1000);

    return () => {
      resizeObserver.disconnect();
      mutationObserver.disconnect();
      clearInterval(interval);
    };
  }, []);

  return (
    <div ref={containerRef}>
      <Helmet>
        {/* TODO Не нравится, переделать на классы? */}
        <style>{`html, body { background: transparent !important; }`}</style>
      </Helmet>

      <DealerRegistrationFormWidget />
    </div>
  );
};
